/** Top-center Fortnite-style level / XP bar (0–100 XP per level). */
export class FpsXpBar {
  private readonly root: HTMLDivElement;
  private readonly fill: HTMLDivElement;
  private readonly label: HTMLDivElement;
  private level = 1;
  private xpInLevel = 0;
  private disposed = false;

  constructor(mount: HTMLElement) {
    this.root = document.createElement('div');
    this.root.style.cssText = [
      'position:fixed',
      'top:14px',
      'left:50%',
      'transform:translateX(-50%)',
      'width:min(420px,70vw)',
      'max-width:420px',
      'z-index:40',
      'pointer-events:none',
      'box-sizing:border-box',
    ].join(';');

    const panel = document.createElement('div');
    panel.style.cssText = [
      'position:relative',
      'height:28px',
      'border-radius:8px',
      'background:rgba(12,16,28,0.92)',
      'border:2px solid #2ee6ff',
      'box-shadow:0 4px 18px rgba(0,0,0,0.45),inset 0 1px 0 rgba(255,255,255,0.06)',
      'overflow:hidden',
    ].join(';');

    this.fill = document.createElement('div');
    this.fill.style.cssText = [
      'position:absolute',
      'left:0',
      'top:0',
      'bottom:0',
      'width:0%',
      'background:linear-gradient(90deg,#ffd54a 0%,#2ee6ff 55%,#5af0ff 100%)',
      'box-shadow:inset 0 -2px 0 rgba(0,0,0,0.18)',
      'transition:width 0.18s ease-out',
    ].join(';');

    this.label = document.createElement('div');
    this.label.style.cssText = [
      'position:relative',
      'z-index:1',
      'height:100%',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'font:800 12px system-ui,sans-serif',
      'letter-spacing:0.06em',
      'color:#f4fbff',
      'text-shadow:0 1px 2px rgba(0,0,0,0.65)',
    ].join(';');

    panel.appendChild(this.fill);
    panel.appendChild(this.label);
    this.root.appendChild(panel);
    mount.appendChild(this.root);
    this.render();
  }

  addXp(amount: number): boolean {
    if (this.disposed || !Number.isFinite(amount) || amount <= 0) {
      return false;
    }

    let leveled = false;
    this.xpInLevel += amount;
    while (this.xpInLevel >= 100) {
      this.xpInLevel -= 100;
      this.level += 1;
      leveled = true;
    }

    this.render();
    return leveled;
  }

  getLevel(): number {
    return this.level;
  }

  private render(): void {
    this.fill.style.width = `${Math.max(0, Math.min(100, this.xpInLevel))}%`;
    this.label.textContent = `LEVEL ${this.level}`;
  }

  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    this.root.remove();
  }
}
